export default __webpack_public_path__ + "static/media/save.70533715.svg";